import { defineMessages } from 'react-intl';

export default defineMessages({
  salesSummary: {
    defaultMessage: 'Sales ({currency})',
    id: 'x8mTZq',
    description: 'sales in seller currency y-axis label',
  },
  salesVsLastPeriod: {
    defaultMessage: 'Sales vs Last Period',
    id: '8SUIfB',
    description: 'Sales vs Last Period label',
  },
  salesVsTimeLastYear: {
    defaultMessage: 'Sales vs Time Last Year',
    id: 'pwV699',
    description: 'Sales vs Time Last Year label',
  },
  averageOrderValue: {
    defaultMessage: 'Average Order Value ({currency})',
    id: 'X8bLnN',
    description: 'Average Order Value label',
  },
  orders: {
    defaultMessage: 'Orders',
    id: '+DChmA',
    description: 'Orders label',
  },
  newCustomers: {
    defaultMessage: 'New Customers',
    id: '7vgBS9',
    description: 'new customers label',
  },
  returningCustomers: {
    defaultMessage: 'Returning Customers',
    id: 'DpbU46',
    description: 'Returning customers label',
  },
  sales: {
    defaultMessage: 'Sales ({currency})',
    id: 'gxiIgJ',
    description: 'sales with currency label used in tooltip and legend',
  },
  productSalesDataLink: {
    defaultMessage: 'See all product sales data',
    id: 'vujwhs',
    description: 'link to product sales report page',
  },
  shipmentNotificationEmailsTitle: {
    description: 'graph title for the shipment notification emails chart',
    defaultMessage: 'Shipment Confirmation Emails',
    id: '04M6lu',
  },
  deliveryNotificationEmailsTitle: {
    description: 'graph title for the delivery notification emails chart',
    defaultMessage: 'Delivery Notification Emails',
    id: 'Zx1WPC',
  },
  turnOnShipmentNotificationEmailsMessage: {
    description: 'description of shipment confirmation emails and instructions on how to turn them on',
    defaultMessage:
      "You haven't enabled Shipment Confirmation Emails. To notify your customers when their order has shipped, select a Shipment Confirmation Email template in your store's <link>Email Settings</link>.",
    id: '8Xw53z',
  },
  turnOnDeliveryNotificationEmailsMessage: {
    description: 'description of delivery notification emails and instructions on how to turn them on',
    defaultMessage:
      "You haven't enabled Delivery Notification Emails. To notify your customers when their order has been delivered, select a Delivery Notification Email template in your store's <link>Email Settings</link>.",
    id: 'Lc8ysE',
  },
  customerDataLink: {
    defaultMessage: 'See full customer report',
    id: '7gaFLu',
    description: 'link that redirects to customer report page',
  },
});
